/* cart-footer-fix.js v6.30 - presents LBF_SHIPPING.compute(); decides no policy itself.
 * v6.30 (2026-09-17) removed this file's parallel copy of the shipping calculation.
 * Every threshold, rate, free/not-free and mixed-cart decision now comes from
 * assets/lbf-shipping-core.js, so the cart page, the collection floating bar and
 * the shared popup cannot drift apart. This file only renders. */
(function () {
  'use strict';
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };
  var CORE = window.LBF_SHIPPING;
  var FROZEN_TAGS = ['frozen', 'fbundle', 'cny frozen'];
  /* Values come from Theme settings via window.LBF_SHIPPING_CONFIG (snippet: lbf-shipping-config.liquid). Fallbacks = previous hardcoded live values. */
  var LBFCFG = window.LBF_SHIPPING_CONFIG || {};
  function lbfRM(c){ return 'RM' + (Number(c||0)/100).toFixed(2); }
  function lbfRMWhole(c){ return 'RM' + Math.round(Number(c||0)/100); }
  /* Thresholds and rates are DELIBERATELY not held in this file any more - they
     live in lbf-shipping-core.js and arrive on the computed result. RD is the
     one survivor and it is presentational only: the resting placeholder in the
     shipping row before the first cart fetch resolves. */
  var RD = lbfRM(LBFCFG.RD != null ? LBFCFG.RD : 800);
  /* Pill sets per cart context */
  var STATES_DRY = [['west-msia', 'West Msia'], ['east-msia', 'East Msia']];
  var STATES_FROZEN = [['kl-sel', 'KL/SEL'], ['wm', 'Other WM']];
  var cartState = null, tagCache = {}, lock = false;
  var previousShippingKind = null, regionPromptFired = false, shippingCheckoutBlocked = false;

  function getSection() {
    return document.querySelector('[id$="__cart-footer"]') || document.getElementById('main-cart-footer');
  }

  function isCartEmpty() {
    var main = document.getElementById('main-cart-footer');
    if (main && main.classList.contains('is-empty')) return true;
    return !document.querySelector('.cart-item');
  }

  function injectCSS() {
    if (document.getElementById('lbf-cart-css')) return;
    var s = document.createElement('style');
    s.id = 'lbf-cart-css';
    s.textContent = '.cart__footer small.tax-note,[id$="__cart-footer"] small.tax-note,small.tax-note.caption-large.rte,.totals+small.tax-note,.totals~small.tax-note{display:none!important}'
      /* Subtotal row: force flex space-between, label left, value right */
      + '[id$="__cart-footer"] .totals:not(.lbf-shipping-block){display:flex!important;justify-content:space-between!important;align-items:center!important;gap:8px!important;width:100%!important}'
      /* Use the actual h2 text for Subtotal; JS replaces Dawn's "Estimated total". */
      + '[id$="__cart-footer"] .totals:not(.lbf-shipping-block)>.totals__total{display:flex!important;align-items:center!important;gap:6px!important;font-size:20px!important;font-weight:700!important;line-height:normal!important;position:relative!important;flex:1 1 auto!important;min-width:0!important;white-space:nowrap!important;margin:0!important;color:rgb(var(--color-foreground,18,18,18))!important}'
      + '[id$="__cart-footer"] .totals:not(.lbf-shipping-block)>.totals__total::before{content:none!important;display:none!important}'
      /* Force Subtotal VALUE (Dawn price element) to match label size + force black */
      + '[id$="__cart-footer"] .totals:not(.lbf-shipping-block)>.totals__subtotal,[id$="__cart-footer"] .totals:not(.lbf-shipping-block)>p,[id$="__cart-footer"] .totals:not(.lbf-shipping-block) .totals__subtotal-value{font-size:20px!important;font-weight:700!important;text-align:right!important;margin:0!important;line-height:normal!important;color:rgb(var(--color-foreground,18,18,18))!important}'
      /* Items count: explicit px size (NOT em — em inherits font-size:0 from parent) */
      + '.lbf-items-count{display:inline-block!important;font-weight:500;font-size:12px;color:#888;margin-left:0;white-space:nowrap;vertical-align:baseline;line-height:normal;flex:0 0 auto!important}'
      /* Our shipping block — matches Dawn .totals layout exactly */
      + '.lbf-shipping-block{display:flex!important;justify-content:space-between!important;align-items:center!important;gap:8px;width:100%;margin-top:4px;padding:0;border:0}'
      + '.lbf-shipping-block .lbf-ship-label{font-size:20px;font-weight:700;color:rgb(var(--color-foreground,18,18,18));white-space:nowrap;flex-shrink:0;margin:0;line-height:normal}'
      + '.lbf-shipping-block .lbf-ship-value{font-size:20px;font-weight:700;color:rgb(var(--color-foreground,18,18,18));text-align:right;margin:0;line-height:normal;white-space:nowrap}'
      + '.lbf-shipping-hint{font-size:11px;color:#777;text-align:right;line-height:1.4;margin:2px 0 6px;display:none}'
      /* FREE in green */
      + '.lbf-free{color:#2D8A2D;font-weight:800;font-size:20px;letter-spacing:.3px}'
      + '.lbf-anchor{text-decoration:line-through;color:#999;font-weight:400;font-size:14px;margin-right:6px}'
      + '.lbf-split-more{color:#1A5490;font-weight:800;margin-left:2px}'
      /* Select state placeholder for Shipping value (muted, not bold) */
      + '.lbf-select-state-text{font-size:15px;font-weight:500;color:#999}'
      /* East Msia rate placeholder — Shopify computes at checkout */
      + '.lbf-east-rate{font-size:13px;font-weight:500;color:#777}'
      /* Bracket label next to "Shipping" — matches .lbf-items-count styling */
      + '.lbf-ship-state-bracket{font-weight:500;font-size:12px;color:#888;margin-left:6px;white-space:nowrap;vertical-align:baseline}'
      /* Cold chain note (v6.18) — blue info chip, one-line look; shown only for frozen/mix carts */
      + '.lbf-cold-chain-note{display:flex;align-items:center;gap:6px;background:#EAF2FB;color:#1A5490;padding:6px 10px;border-radius:6px;font-size:11px;font-weight:500;line-height:1.3;margin-top:6px}'
      /* State picker row — Shipping state label + KL/SEL + Other WM pills */
      + '.lbf-state-row{display:flex;flex-direction:row;align-items:center;gap:8px;margin-top:6px;flex-wrap:wrap}'
      + '.lbf-state-label{font-size:12px;font-weight:600;color:#555;flex-shrink:0}'
      + '.lbf-state-pills{display:flex;gap:6px;flex-wrap:wrap;flex:1;justify-content:flex-end}'
      + '.lbf-state-pill{padding:6px 12px;border-radius:999px;border:1.5px solid #ddd;background:#fff;font-size:11px;font-weight:600;color:#333;cursor:pointer;font-family:inherit;line-height:1.2;white-space:nowrap}'
      + '.lbf-state-pill:hover{border-color:#999}'
      /* Pill rate preview (shows outcome of selecting that state) */
      + '.lbf-pill-sep{color:#bbb;font-weight:400;margin:0 2px}'
      + '.lbf-pill-rate{font-weight:600;color:#555}'
      + '.lbf-pill-rate-free{color:#2D8A2D;font-weight:800;letter-spacing:.2px}'
      /* Status box — shown after state is picked */
      + '.lbf-status-box{display:flex;align-items:center;gap:8px;padding:8px 12px;border-radius:8px;font-size:12px;margin-top:6px;font-weight:500;line-height:1.3}'
      + '.lbf-status-success{background:#E6F4EA;color:#1B7B1B}'
      + '.lbf-status-warn{background:#FFE8D6;color:#8B4500}'
      + '.lbf-status-info{background:#EAF2FB;color:#1A5490}'
      + '.lbf-status-danger{background:#FDECEC;color:#9A2525}'
      + '.lbf-status-icon{width:18px;height:18px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;color:#fff;font-size:11px;font-weight:700;line-height:1}'
      + '.lbf-status-success .lbf-status-icon{background:#2D8A2D}'
      + '.lbf-status-warn .lbf-status-icon{background:#E89B3B}'
      + '.lbf-status-info .lbf-status-icon{background:#4A90E2}'
      + '.lbf-status-danger .lbf-status-icon{background:#C93636}'
      + '.lbf-status-text{flex:1}'
      /* Region action — same pill selector treatment as the collection bar. */
      + '.lbf-cart-region-chip{flex:0 0 auto;background:#fff;border:1.5px solid #bfe0c6;color:#2D8A2D;font-size:11px;font-weight:800;padding:4px 8px 4px 11px;border-radius:999px;cursor:pointer;font-family:inherit;display:inline-flex;align-items:center;gap:4px;white-space:nowrap;line-height:1.2}'
      + '.lbf-cart-region-chip.is-pick{border-color:#d3a256;color:#8B4500}'
      + '.lbf-cart-region-chip.is-danger{border-color:#C93636;color:#fff;background:#C93636}'
      + '.lbf-cart-region-chip svg{width:11px;height:11px;display:block}'
      + '.lbf-status-text strong{font-weight:800}'
      + '.lbf-change-state{background:none;border:none;color:inherit;text-decoration:underline;font-size:11px;cursor:pointer;padding:0;font-family:inherit;opacity:.75;flex-shrink:0}'
      + '.lbf-change-state:hover{opacity:1}'
      + '.lbf-sabah-link{text-align:center;margin-top:10px;font-size:12px}'
      + '.lbf-sabah-link button{background:none;border:none;padding:4px 8px;font:inherit;color:#666;text-decoration:underline;text-decoration-color:#ccc;text-underline-offset:2px;cursor:pointer}'
      + '.lbf-sabah-link button:hover{color:#111}'
      /* CHECKOUT button — always uppercase, bold, FULL width (v6.20: override Dawn's max-width:36rem cap) */
      + '[id$="__cart-footer"] #checkout,[id$="__cart-footer"] button[name="checkout"],[id$="__cart-footer"] .cart__checkout-button{text-transform:uppercase!important;font-weight:700!important;letter-spacing:.5px!important;max-width:none!important;width:100%!important;box-sizing:border-box!important}'
      /* Match the disabled CTA on the live RTE meal-box builder. */
      + '[id$="__cart-footer"] #checkout[aria-disabled="true"],[id$="__cart-footer"] button[name="checkout"][aria-disabled="true"],[id$="__cart-footer"] .cart__checkout-button[aria-disabled="true"]{background:#E7E1DC!important;background-color:#E7E1DC!important;color:#9A8F88!important;border:0!important;border-radius:8px!important;box-shadow:none!important;opacity:1!important;cursor:not-allowed!important}'
      + '[id$="__cart-footer"] #checkout[aria-disabled="true"]:before,[id$="__cart-footer"] #checkout[aria-disabled="true"]:after,[id$="__cart-footer"] button[name="checkout"][aria-disabled="true"]:before,[id$="__cart-footer"] button[name="checkout"][aria-disabled="true"]:after,[id$="__cart-footer"] .cart__checkout-button[aria-disabled="true"]:before,[id$="__cart-footer"] .cart__checkout-button[aria-disabled="true"]:after{box-shadow:none!important;border:0!important}'
      /* Mobile sticky — preserve horizontal page-width padding, modest bottom buffer for cart-note (no 200px gap) */
      /* Hide helper for frozen-warning state */
      + '.lbf-hidden{display:none!important}'
      + '@media(max-width:749px){#shopify-section-cart-footer,[id^="shopify-section-"][id$="cart-footer"]{background:#ffffff!important;background-color:#ffffff!important;background-image:none!important;width:100%!important;max-width:100%!important;margin-left:0!important;margin-right:0!important}[id$="__cart-footer"] .page-width,.cart__footer .page-width{background:transparent!important;padding-left:0!important;padding-right:0!important;max-width:100%!important;width:100%!important}[id$="__cart-footer"] .cart__blocks,.cart__footer .cart__blocks{background:transparent!important}[id$="__cart-footer"] #checkout,[id$="__cart-footer"] button[name="checkout"],[id$="__cart-footer"] .cart__checkout-button{padding-top:18px!important;padding-bottom:18px!important;font-size:18px!important;min-height:56px!important;letter-spacing:1px!important}[id$="__cart-footer"],.cart__footer{position:sticky!important;bottom:0!important;background:#ffffff!important;background-color:#ffffff!important;background-image:none!important;z-index:5!important;box-shadow:0 -4px 16px rgba(0,0,0,.06)!important;padding-top:8px!important;padding-bottom:4px!important;padding-left:14px!important;padding-right:14px!important;box-sizing:border-box!important;width:100vw!important;max-width:100vw!important;margin-left:calc(50% - 50vw)!important;margin-right:calc(50% - 50vw)!important;--padding-bottom-section:4px!important;--color-background:255,255,255!important;margin-bottom:0!important}[id$="__cart-footer"] .js-contents,.cart__footer .js-contents{display:block!important}[id$="__cart-footer"] .cart__ctas,.cart__footer .cart__ctas{margin:6px 0 0!important;padding-top:0!important;padding-bottom:0!important}[id$="__cart-footer"] form,.cart__footer form{margin:0!important;padding:0!important}#main-cart-items,.cart__items{padding-bottom:24px!important}#lbf-cart-note-wrapper{position:static!important;background:#fff!important;padding-top:16px!important;padding-bottom:32px!important;margin:0}#lbf-cart-note-wrapper cart-note,#lbf-cart-note-wrapper textarea{min-height:60px!important;max-height:80px!important;width:100%!important}}'
      /* Desktop — right-column layout: constrain totals/checkout to ~460px right-aligned, smaller cart-note textarea */
      + '@media(min-width:750px){[id$="__cart-footer"] form,.cart__footer form{max-width:460px!important;margin-left:auto!important;margin-right:0!important}[id$="__cart-footer"] .totals,[id$="__cart-footer"] .lbf-shipping-wrapper,[id$="__cart-footer"] .cart__ctas,[id$="__cart-footer"] .cart-block{max-width:460px!important;margin-left:auto!important}#lbf-cart-note-wrapper{max-width:600px!important;padding-top:16px!important;padding-bottom:16px!important}#lbf-cart-note-wrapper cart-note,#lbf-cart-note-wrapper textarea{min-height:60px!important;max-height:90px!important;width:100%!important}}'
      /* Tooltip */
      + '.lbf-tooltip-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:99998;display:none;opacity:0;transition:opacity .18s}'
      + '.lbf-tooltip-backdrop.open{display:block;opacity:1}'
      + '.lbf-tooltip-card{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%) scale(.96);background:#fff;border-radius:12px;padding:20px 18px 18px;max-width:360px;width:calc(100% - 32px);box-shadow:0 16px 40px rgba(0,0,0,.22);z-index:99999;display:none;opacity:0;transition:opacity .2s,transform .2s}'
      + '.lbf-tooltip-card.open{display:block;opacity:1;transform:translate(-50%,-50%) scale(1)}'
      + '.lbf-tooltip-card h3{font-size:15px;font-weight:800;margin:0 24px 8px 0;color:#111}'
      + '.lbf-tooltip-close{position:absolute;top:10px;right:12px;background:none;border:none;cursor:pointer;font-size:22px;line-height:1;color:#999;padding:0;width:28px;height:28px;display:flex;align-items:center;justify-content:center}'
      + '.lbf-tooltip-close:hover{color:#111}'
      + '.lbf-rate-section-label{margin:12px 0 6px;font-weight:700;color:#444;font-size:12px}'
      + '.lbf-rate-row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px dashed #eee;font-size:13px}'
      + '.lbf-rate-row:last-of-type{border-bottom:none}'
      + '.lbf-rate-row>:first-child{color:#555}'
      + '.lbf-rate-row>:last-child{font-weight:700;color:#111}'
      + '.lbf-frozen-warning{background:#FFF4E5;border:1px solid #FFD4A0;border-radius:8px;padding:10px 12px;margin-top:12px;font-size:12px;color:#8B4500;line-height:1.45}'
      + '.lbf-tooltip-footer-note{margin-top:12px;font-size:11px;color:#777;line-height:1.4}';
    document.head.appendChild(s);
  }

  /* Render-intercept: replace "Estimated total" -> "Subtotal" in Dawn's response HTML BEFORE DOM swap */
  function patchDawnRender() {
    function patch(elem) {
      if (!elem) return;
      var proto = Object.getPrototypeOf(elem);
      if (!proto || !proto.renderContents || proto._lbfPatched) return;
      proto._lbfPatched = true;
      var orig = proto.renderContents;
      proto.renderContents = function (parsedState) {
        try {
          if (parsedState && parsedState.sections) {
            Object.keys(parsedState.sections).forEach(function (k) {
              var html = parsedState.sections[k];
              if (typeof html === 'string') {
                parsedState.sections[k] = html.replace(/>(\s*)Estimated total(\s*)</g, '>$1Subtotal$2<');
              }
            });
          }
        } catch (e) {}
        return orig.call(this, parsedState);
      };
    }
    document.querySelectorAll('cart-items,cart-drawer-items').forEach(patch);
    var obs = new MutationObserver(function () {
      document.querySelectorAll('cart-items,cart-drawer-items').forEach(patch);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* Move cart-note OUT on mobile (so sticky cart-footer doesn't trap it); on desktop, restore Dawn's natural side-by-side layout */
  function moveCartNoteOut(section) {
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    if (isDesktop) {
      var wrap = document.getElementById('lbf-cart-note-wrapper');
      if (wrap) {
        var n = wrap.querySelector('cart-note');
        if (n) {
          var slot = section.querySelector('.cart__footer') || section.querySelector('.page-width') || section;
          slot.insertBefore(n, slot.firstChild);
          delete n.dataset.lbfMoved;
        }
        wrap.remove();
      }
      return;
    }
    var cartNote = section.querySelector('cart-note');
    if (!cartNote || cartNote.dataset.lbfMoved) return;
    var noteWrapper = document.createElement('div');
    noteWrapper.id = 'lbf-cart-note-wrapper';
    noteWrapper.className = 'page-width';
    section.parentElement.insertBefore(noteWrapper, section);
    noteWrapper.appendChild(cartNote);
    cartNote.dataset.lbfMoved = 'true';
  }

  function hideCartNote() {
    var w = document.getElementById('lbf-cart-note-wrapper');
    if (w) w.style.display = 'none';
  }

  function readInitial() {
    var n = document.querySelector('[data-cart-progress-data]');
    if (!n) return null;
    try { return JSON.parse(n.textContent || '{}'); } catch (e) { return null; }
  }

  function seedCache(d) {
    if (!d || !d.items) return;
    d.items.forEach(function (it) {
      if (it && it.product_id != null) tagCache[it.product_id] = (it.tags || []).map(function (t) { return String(t).toLowerCase(); });
    });
  }

  function refresh() {
    if (lock) return Promise.resolve(null);
    lock = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (live) {
        if (!live) { lock = false; return null; }
        var ps = live.items.map(function (li) {
          var pid = li.product_id, cached = tagCache[pid];
          if (cached) return Promise.resolve({ product_id: pid, key: li.key || '', handle: li.handle, title: li.product_title || '', qty: li.quantity, line_price: li.final_line_price, product_type: li.product_type || '', tags: cached });
          return fetch('/products/' + li.handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              var t = p && p.tags ? p.tags.map(function (x) { return String(x).toLowerCase(); }) : [];
              tagCache[pid] = t;
              return { product_id: pid, key: li.key || '', handle: li.handle, title: li.product_title || '', qty: li.quantity, line_price: li.final_line_price, product_type: li.product_type || (p && p.type) || '', tags: t };
            })
            .catch(function () { return { product_id: pid, key: li.key || '', handle: li.handle, title: li.product_title || '', qty: li.quantity, line_price: li.final_line_price, product_type: li.product_type || '', tags: [] }; });
        });
        return Promise.all(ps).then(function (items) {
          lock = false;
          return { total_price: live.total_price, items_count: live.item_count, items: items };
        });
      })
      .catch(function () { lock = false; return null; });
  }

  function hasFrozen(c) {
    if (!c || !Array.isArray(c.items)) return false;
    return c.items.some(function (it) {
      if (it && it.product_type === 'Frozen') return true;
      var t = (it && it.tags) || [];
      return t.some(function (x) { return FROZEN_TAGS.indexOf(String(x).toLowerCase()) !== -1; });
    });
  }

  function fmt(c) { return 'RM' + (Number(c || 0) / 100).toFixed(2); }

  function regionChip(label, mod) {
    return '<button type="button" class="lbf-cart-region-chip' + (mod ? ' ' + mod : '') + '" data-lbf-change-state aria-haspopup="dialog">'
      + label + ' <svg aria-hidden="true" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.25 6 7.75l3.5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  }

  function stText(l) {
    if (l === 'West Msia') return lbnT('ship.chip_west_msia', 'West Msia');
    if (l === 'East Msia') return lbnT('ship.chip_east_msia', 'East Msia');
    if (l === 'KL/SEL') return lbnT('ship.chip_kl_sel', 'KL/SEL');
    if (l === 'Other WM') return lbnT('ship.chip_other_wm', 'Other WM');
    if (l === 'West Malaysia') return lbnT('ship.west_malaysia', 'West Malaysia');
    if (l === 'Sabah / Sarawak') return lbnT('ship.sabah_sarawak', 'Sabah / Sarawak');
    return l;
  }

  function regionChipLabel(s) {
    if (s.autoFree || s.stateLabel === 'West Malaysia') return 'West Msia';
    if (s.stateLabel === 'KL / Selangor' || s.stateLabel === 'KL/SEL') return 'KL/SEL';
    if (s.stateLabel === 'Outside KL / Selangor' || s.stateLabel === 'Other WM State') return 'Other WM';
    if (s.stateLabel === 'Sabah / Sarawak') return 'East Msia';
    return s.stateLabel || 'West Msia';
  }

  /* Cold-chain "Add X more Frozen item" warning detection — innerText (visibility-aware) so hidden template markup doesn't false-positive. Gated on hasFrozen so dry carts never hit it. */
  function frozenWarningVisible(c) {
    if (!hasFrozen(c)) return false;
    var main = document.querySelector('main') || document.body;
    var t = main.innerText || '';
    return /add\s+\d+\s+more\s+frozen\s+item/i.test(t) || /minimum\s+\d+\s+frozen\s+items?\s+required/i.test(t);
  }

  /* ---------------------------------------------------------------------------
     computeShipping() is now a PRESENTER, not a calculator.

     It used to re-implement every threshold, rate and free-shipping decision
     alongside lbf-shipping-core.js, which is exactly how the cart page and the
     collection bar could drift apart. It now takes the SHARED result from
     LBF_SHIPPING.compute() and only turns it into this section's markup: no
     threshold, no rate and no "is it free" decision is made in this file.
     Numbers are read off the result; the only local values are presentational.
     --------------------------------------------------------------------------- */
  function stateLabelFor(s) {
    var pills = s.frozen ? STATES_FROZEN : STATES_DRY;
    for (var i = 0; i < pills.length; i++) { if (pills[i][0] === s.state) return pills[i][1]; }
    return null;
  }

  /* FIX B (2026-09-18): when a split-parcel item shares the cart, checkout quotes
     TWO parcels added together and the theme can only price one. Measured live:
     PPK + minced pork = RM38 (RM30 + RM8), PPK + 3 soups + minced pork = RM60
     (RM30 + a whole second cold-chain parcel) - against RM30 shown either way.
     So we stop asserting one number and say a second fee follows. Accurate beats
     tidy until the engine can price both parcels (needs ShipZip's Seasonal table). */
  function applySplitWarning(out, s) {
    var q = s && s.split;
    if (q && q.quotable) {
      /* The honest total: each box priced on its own tier, added up. */
      out.val = q.total === 0 ? '<span class="lbf-free">' + lbnT('ship.free_caps', 'FREE') + '</span>' : lbfRM(q.total);
      /* The Shipping row right above already shows the total, so repeating the
         split here was noise. This line only has to flag that it IS a split. */
      out.status = { type: 'info', text: lbnT('ship.ff_two_boxes', 'Ships in 2 boxes') };
    } else {
      out.val = out.val + '<span class="lbf-split-more">+</span>';
      out.status = { type: 'info', text: lbnT('ship.ff_two_boxes_second_fee', 'Ships in 2 boxes · second delivery fee shown at checkout') };
    }
    out.splitWarn = true;
    return out;
  }

  function computeShipping(s) {
    var pills = s.frozen ? STATES_FROZEN : STATES_DRY;

    if (s.kind === 'empty' || s.kind === 'moq') {
      /* The whole shipping block is hidden in these states (see hideTotals in
         render), so this only keeps the markup in a sane resting position. */
      return { kind: s.kind, val: RD, needsState: false, status: null, stateLabel: null, pills: pills };
    }

    if (s.kind === 'blocked') {
      return { kind: 'blocked', val: '<span class="lbf-east-rate" style="color:#C93636">' + lbnT('ship.not_available', 'Not available') + '</span>', needsState: false,
        status: { type: 'danger', text: lbnT('ship.ff_blocked_east', "We can't deliver frozen food to East Malaysia") }, stateLabel: 'Sabah / Sarawak', pills: pills };
    }

    if (s.kind === 'pickstate') {
      return { kind: 'pickstate', val: '<span class="lbf-select-state-text">' + lbnT('ship.ff_select_region', 'Select region') + '</span>', needsState: true,
        status: { type: 'warn', text: lbnT('ship.ff_select_area', 'Select your shipping area') }, stateLabel: null, pills: pills };
    }

    if (s.kind === 'eastmsia') {
      return { kind: 'eastmsia', val: '<span class="lbf-east-rate">' + lbnT('ship.from_amount', 'From {{ amount }}', { amount: lbfRM(s.from) }) + '</span>', needsState: false,
        status: { type: 'info', text: lbnT('ship.east_weight_based', 'Weight-based \u00b7 exact rate at checkout') },
        stateLabel: stateLabelFor(s), pills: pills };
    }

    /* Any order containing frozen food uses a reduced-fee cold-chain tier. */
    if (s.kind === 'mixed-progress') {
      return { kind: 'mixed-progress', val: lbfRM(s.rate), needsState: false,
        status: { type: 'warn', text: (CORE.seasonalNudge && CORE.seasonalNudge(s)) || lbnT('ship.add_to_save_on_delivery', 'Add {{ amount }} to save {{ saving }} on delivery', { amount: lbfRM(s.remaining), saving: lbfRMWhole(s.baseRate - s.floorRate) }) },
        stateLabel: stateLabelFor(s), pills: pills };
    }
    if (s.kind === 'mixed-floor') {
      /* Struck-through base rate beside the reduced one - the same treatment the
         KL frozen mid-tier already uses, so the saving is visible here too. */
      /* A seasonal box reaching free shows FREE, not RM0.00 */
      return { kind: 'mixed-floor', val: '<span class="lbf-anchor">' + lbfRM(s.baseRate) + '</span>' + (s.rate === 0 ? '<span class="lbf-free">' + lbnT('ship.free_caps', 'FREE') + '</span>' : lbfRM(s.rate)), needsState: false,
        status: { type: 'success', text: s.rate === 0 ? lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') : lbnT('ship.you_saved_on_delivery', 'You saved {{ amount }} on delivery', { amount: lbfRMWhole(s.baseRate - s.floorRate) }) },
        stateLabel: stateLabelFor(s), pills: pills };
    }

    if (s.kind === 'free') {
      return { kind: 'free', val: '<span class="lbf-free">' + lbnT('ship.free_caps', 'FREE') + '</span>', needsState: false,
        status: { type: 'success', text: lbnT('ship.ff_free_unlocked', 'Free shipping unlocked!') },
        stateLabel: s.autoFree ? 'West Malaysia' : (s.frozen ? stateLabelFor(s) : 'West Malaysia'),
        pills: pills, autoFree: !!s.autoFree };
    }

    /* kind === 'progress' */
    var shipVal = lbfRM(s.rate);
    if (s.frozen && s.state === 'kl-sel' && s.rate === CORE.RF_KL_RED) {
      shipVal = '<span class="lbf-anchor">' + lbfRM(CORE.RF_KL) + '</span>' + lbfRM(s.rate);
    }
    return { kind: 'progress', val: shipVal, needsState: false,
      status: { type: 'warn', text: lbnT('ship.ff_more_for_free_shipping', '{{ amount }} more for free shipping', { amount: lbfRM(s.remaining) }) },
      stateLabel: stateLabelFor(s), pills: pills };
  }

  /* Ensure stable shipping wrapper exists OUTSIDE .js-contents so Dawn's AJAX
     re-render of .js-contents doesn't wipe it. Wrapper sits between .js-contents
     and .cart__ctas. */
  function ensureShippingWrapper(sec) {
    var existing = sec.querySelector('.lbf-shipping-wrapper');
    if (existing) return existing;
    var jsc = sec.querySelector('.js-contents');
    var ctas = sec.querySelector('.cart__ctas');
    if (!jsc || !ctas) return null;
    var w = document.createElement('div');
    w.className = 'lbf-shipping-wrapper';
    w.innerHTML = '<div class="totals lbf-shipping-block"><h2 class="lbf-ship-label">' + lbnT('cart.footer_shipping', 'Shipping') + '<span class="lbf-ship-state-bracket"></span></h2><p class="lbf-ship-value">' + RD + '</p></div>'
      + '<div class="lbf-cold-chain-note" style="display:none"><span>❄️</span><span style="flex:1">' + lbnT('ship.ff_cold_chain_note', 'Cold Chain Delivery · Packed in Insulated Packaging') + '</span></div>'
      + '<div class="lbf-status-box" style="display:none"></div>';
    jsc.insertAdjacentElement('afterend', w);
    return w;
  }

  function render() {
    if (!cartState) return;
    var popupSnapshot = popupCart();
    var frozenSnapshot = popupSnapshot.items.some(function (item) { return item.frozenTag; });
    var flowState = CORE.compute(popupSnapshot, CORE.activeRegion(frozenSnapshot), {});
    var hideTotals = frozenWarningVisible(cartState) || flowState.kind === 'moq';
    var frozenRegionMissing = frozenSnapshot && flowState.kind !== 'free' && CORE.getRegularRegion() !== 'east-msia' && !CORE.getFrozenRegion();
    var frozenEastBlocked = frozenSnapshot && flowState.kind === 'blocked';
    shippingCheckoutBlocked = frozenRegionMissing || frozenEastBlocked;
    document.querySelectorAll('[id$="__cart-footer"]').forEach(function (sec) {
      /* (z) Hide Subtotal + Shipping rows when cold-chain frozen warning is shown */
      var subtotalRow = sec.querySelector('.totals:not(.lbf-shipping-block)');
      if (subtotalRow) subtotalRow.classList.toggle('lbf-hidden', hideTotals);
      var shipWrap = sec.querySelector('.lbf-shipping-wrapper');
      if (shipWrap) shipWrap.classList.toggle('lbf-hidden', hideTotals);

      /* (a) Items count on existing Subtotal h2 — kept inside .js-contents (Dawn re-renders it, we re-add) */
      var h2 = sec.querySelector('.totals:not(.lbf-shipping-block) h2.totals__total');
      if (h2) {
        var cnt = cartState.items_count || 0;
        var newCnt = '(' + lbnT('cart.ff_items_count', '{{ n }} items', { n: cnt }) + ')';
        Array.prototype.slice.call(h2.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && node.textContent.trim() !== 'Subtotal') node.textContent = 'Subtotal';
        });
        if (!Array.prototype.some.call(h2.childNodes, function (node) { return node.nodeType === 3 && node.textContent.trim() === 'Subtotal'; })) {
          h2.insertBefore(document.createTextNode('Subtotal'), h2.firstChild);
        }
        var sp = h2.querySelector('.lbf-items-count');
        if (!sp) {
          sp = document.createElement('span');
          sp.className = 'lbf-items-count';
          h2.appendChild(sp);
        }
        if (sp.textContent !== newCnt) sp.textContent = newCnt;
      }

      /* (b) Shipping line — uses a STABLE wrapper outside .js-contents.
         Update content in place, don't remove/re-insert (prevents flicker). */
      var w = ensureShippingWrapper(sec);
      if (w) {
        var s = computeShipping(flowState);
        /* Never on the MOQ/blocked/pickstate states - those have their own message
           and the shopper cannot check out from them anyway. */
        if (flowState.splitWarn && s.status && ['moq', 'blocked', 'pickstate', 'empty'].indexOf(s.kind) === -1) applySplitWarning(s, flowState);
        var valEl = w.querySelector('.lbf-ship-value');
        if (valEl && valEl.innerHTML !== s.val) valEl.innerHTML = s.val;

        /* Cold chain subtext (v6.17): show only for frozen/mix carts */
        var coldNote = w.querySelector('.lbf-cold-chain-note');
        if (coldNote) coldNote.style.display = flowState.frozen ? '' : 'none';

        /* Update (State) bracket beside "Shipping" label */
        var bracket = w.querySelector('.lbf-ship-state-bracket');
        if (bracket) {
          var bText = s.stateLabel ? ' (' + stText(s.stateLabel) + ')' : '';
          if (bracket.textContent !== bText) bracket.textContent = bText;
        }

        var statusBox = w.querySelector('.lbf-status-box');

        if (s.needsState) {
          if (statusBox) {
            statusBox.style.display = '';
            statusBox.className = 'lbf-status-box lbf-status-warn';
            statusBox.innerHTML = '<span class="lbf-status-icon">i</span><span class="lbf-status-text">' + lbnT('ship.ff_select_area_checkout', 'Select your shipping area to enable checkout') + '</span>' + regionChip(lbnT('ship.ff_select_region', 'Select region'), 'is-pick');
          }
        } else if (s.status) {
          if (statusBox) {
            statusBox.style.display = '';
            statusBox.className = 'lbf-status-box lbf-status-' + s.status.type;
            var icon = s.status.type === 'success' ? '✓' : (s.status.type === 'danger' ? '!' : 'i');
            var html = '<span class="lbf-status-icon">' + icon + '</span><span class="lbf-status-text">' + s.status.text + '</span>'
              + regionChip(s.kind === 'blocked' ? lbnT('ship.ff_fix_this', 'Fix this') : stText(regionChipLabel(s)), s.kind === 'blocked' ? 'is-danger' : '');
            if (statusBox.innerHTML !== html) statusBox.innerHTML = html;
          }
        } else if (statusBox) {
          statusBox.style.display = 'none';
        }
      }

      /* (c) Force checkout button text to one word: "Checkout" (CSS uppercases to CHECKOUT) */
      var coBtn = sec.querySelector('#checkout,button[name="checkout"],.cart__checkout-button');
      if (coBtn) {
        var coTxt = (coBtn.textContent || '').trim();
        var checkoutText = frozenRegionMissing ? 'Select shipping region to checkout' : 'Checkout';
        if (coTxt !== checkoutText) coBtn.textContent = checkoutText;
        if (shippingCheckoutBlocked) coBtn.setAttribute('data-lbf-shipping-blocked', '1');
        else coBtn.removeAttribute('data-lbf-shipping-blocked');
        var combinedBlocked = shippingCheckoutBlocked || sec.classList.contains('lbf-moq-blocked');
        if (coBtn.tagName.toLowerCase() !== 'a') coBtn.disabled = combinedBlocked;
        coBtn.setAttribute('aria-disabled', combinedBlocked ? 'true' : 'false');
        coBtn.style.opacity = combinedBlocked ? '1' : '';
        coBtn.style.cursor = combinedBlocked ? 'not-allowed' : '';
      }
    });
    var latest = computeShipping(flowState);
    CORE.trackLane('cart', flowState);
    if (latest.kind === 'blocked' && previousShippingKind !== 'blocked') {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lbf_blocked_view', surface: 'cart', cart_value: cartState.total_price || 0, frozen_qty: popupSnapshot.items.reduce(function (n, item) { return n + (item.frozenTag && item.linePrice !== 0 ? item.qty : 0); }, 0) });
      } catch (e) {}
      try {
        if (!sessionStorage.getItem('lbf-ship-popup-seen')) {
          sessionStorage.setItem('lbf-ship-popup-seen', '1');
          setTimeout(function () { if (window.LBF_SHIPPING_POPUP) window.LBF_SHIPPING_POPUP.open({ cart: popupSnapshot, step: 2, trigger: 'auto' }); }, 0);
        }
      } catch (e) {}
    }
    if (frozenSnapshot && !flowState.autoFree && flowState.kind !== 'moq' && flowState.kind !== 'blocked' && !CORE.getFrozenRegion() && !regionPromptFired) {
      regionPromptFired = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lbf_region_prompt', surface: 'cart', cart_value: flowState.total, frozen_qty: flowState.frozenQty });
      } catch (e) {}
      /* Cart journey 2026-09-26 (Carl + panel): the area picker no longer opens by itself.
         The Shipping row's "Choose area" chip is the entry point; only the Sabah/Sarawak
         block is still forced. */
    }
    previousShippingKind = latest.kind || (latest.needsState ? 'pickstate' : 'normal');
    if (window.LBF_SHIPPING_POPUP) window.LBF_SHIPPING_POPUP.update(popupSnapshot);
  }

  function popupCart() {
    var items = (cartState && cartState.items) || [];
    return {
      totalPrice: (cartState && cartState.total_price) || 0,
      items: items.map(function (item) {
        var tags = item.tags || [];
        var type = String(item.product_type || '').toLowerCase();
        var frozen = type === 'frozen' || tags.some(function (tag) { return FROZEN_TAGS.indexOf(String(tag).toLowerCase()) !== -1; });
        return { key: item.key || '', qty: item.qty || 0, linePrice: item.line_price == null ? 1 : item.line_price,
          frozenType: frozen, frozenTag: frozen, retortType: type === 'retort', soloOk: tags.indexOf('cc_solo_ok') !== -1,
          title: item.title || '' };
      })
    };
  }

  function ensureTooltip() {
    if (document.getElementById('lbf-sabah-card')) return;
    var bd = document.createElement('div');
    bd.id = 'lbf-sabah-backdrop'; bd.className = 'lbf-tooltip-backdrop';
    var card = document.createElement('div');
    card.id = 'lbf-sabah-card'; card.className = 'lbf-tooltip-card';
    card.setAttribute('role', 'dialog');
    card.innerHTML = '<button type="button" class="lbf-tooltip-close" data-lbf-tooltip-close>×</button>'
      + '<h3>Shipping to Sabah / Sarawak</h3>'
      + '<div class="lbf-rate-section-label">Dry goods (weight-based):</div>'
      + '<div class="lbf-rate-row"><span>First 1 kg</span><span>RM16.00</span></div>'
      + '<div class="lbf-rate-row"><span>Each additional 1 kg</span><span>RM10.00</span></div>'
      + '<div class="lbf-rate-row"><span>Example: 3 kg order</span><span>RM36.00</span></div>'
      + '<div class="lbf-rate-row"><span>Free shipping</span><span style="color:#999;">Not available</span></div>'
      + '<div class="lbf-frozen-warning"><strong>❄️ Frozen items unavailable</strong><br>Cold chain delivery only ships within West Malaysia.</div>'
      + '<div class="lbf-tooltip-footer-note">Final shipping calculated at checkout based on actual weight and delivery postcode.</div>';
    document.body.appendChild(bd);
    document.body.appendChild(card);
    function close() { card.classList.remove('open'); bd.classList.remove('open'); document.body.style.overflow = ''; }
    bd.addEventListener('click', close);
    card.querySelector('[data-lbf-tooltip-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && card.classList.contains('open')) close(); });
  }

  function bindTriggers() {
    if (document._lbfBound) return;
    document._lbfBound = true;
    document.addEventListener('click', function (e) {
      var tgt = e.target;
      if (!tgt || !tgt.closest) return;
      var checkout = tgt.closest('#checkout,button[name="checkout"],input[name="checkout"],a[href^="/checkout"],.cart__checkout-button');
      if (checkout && shippingCheckoutBlocked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var warning = document.querySelector('.lbf-shipping-wrapper .lbf-status-warn,.lbf-shipping-wrapper .lbf-status-danger');
        if (warning && warning.scrollIntoView) warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var sabah = tgt.closest('[data-lbf-sabah-trigger]');
      if (sabah) {
        e.preventDefault();
        var card = document.getElementById('lbf-sabah-card');
        var bd = document.getElementById('lbf-sabah-backdrop');
        if (card && bd) { card.classList.add('open'); bd.classList.add('open'); document.body.style.overflow = 'hidden'; }
        return;
      }
      var ch = tgt.closest('[data-lbf-change-state]');
      if (ch) {
        e.preventDefault();
        if (window.LBF_SHIPPING_POPUP) window.LBF_SHIPPING_POPUP.open({ cart: popupCart(), step: 1, trigger: 'region', reason: 'manual', opener: ch });
        return;
      }
    });
    document.addEventListener('submit', function (e) {
      if (!shippingCheckoutBlocked) return;
      var submitter = e.submitter;
      if ((submitter && (submitter.name === 'checkout' || submitter.id === 'checkout')) || (e.target && e.target.querySelector && e.target.querySelector('[name="checkout"]'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function cleanup() {
    var sec = getSection();
    if (!sec) return;
    var jsc = sec.querySelector('.js-contents'), ctas = sec.querySelector('.cart__ctas');
    if (jsc) { jsc.style.position = 'static'; jsc.style.bottom = 'auto'; jsc.style.left = 'auto'; jsc.style.width = 'auto'; jsc.style.zIndex = 'auto'; jsc.style.backgroundColor = ''; }
    if (ctas) { ctas.style.position = 'static'; ctas.style.bottom = 'auto'; ctas.style.left = 'auto'; ctas.style.width = 'auto'; ctas.style.zIndex = 'auto'; ctas.style.backgroundColor = ''; ctas.style.boxShadow = 'none'; }
  }

  function renderAll() {
    var sec = getSection();
    if (!sec) return;
    cleanup();
    if (isCartEmpty()) { hideCartNote(); return; }
    moveCartNoteOut(sec);
    render();
  }

  function refreshAndRender() {
    refresh().then(function (f) { if (f) cartState = f; renderAll(); });
  }

  function init() {
    injectCSS();
    patchDawnRender();
    /* ensureTooltip();  -- Sabah/Sarawak rates tooltip removed in v6.14 (East Msia now a pill choice; Shopify checkout computes weight-based) */
    bindTriggers();
    document.addEventListener('lbf:shipping-state-change', function (e) { if (!e.detail || e.detail.source !== 'cart-footer') renderAll(); });
    document.addEventListener('lbf:remove-frozen-request', function () {
      var updates = {};
      popupCart().items.forEach(function (item) { if (item.frozenTag && item.key) updates[item.key] = 0; });
      if (!Object.keys(updates).length) return;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'lbf_blocked_resolve', via: 'removed_frozen' }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:update')); refreshAndRender();
        }).catch(function () {});
    });
    var d = readInitial();
    seedCache(d);
    if (d) cartState = d;
    renderAll();
    refreshAndRender();
    var root = document.querySelector('#main-cart-items') || document.querySelector('main') || document.body;
    if (typeof MutationObserver !== 'undefined') {
      var tm = null;
      var obs = new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(refreshAndRender, 120); });
      obs.observe(root, { childList: true, subtree: true });
    }
    ['cart:update', 'cart:updated', 'cart:refresh', 'cart:item-added', 'cart:item-removed', 'cart-update'].forEach(function (e) {
      document.addEventListener(e, function () { setTimeout(refreshAndRender, 200); });
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(refreshAndRender, 50);
          setTimeout(refreshAndRender, 300);
        });
      }
    } catch (e) {}
    window.addEventListener('load', function () { setTimeout(refreshAndRender, 200); setTimeout(refreshAndRender, 800); });
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 750px)');
      var onMq = function () { setTimeout(renderAll, 50); };
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
